import React, { useEffect, useState } from 'react';
import Button from './Button';

interface Quote {
  id: number;
  text: string;
  author: string;
}

const quotes: Quote[] = [
  { id: 1, text: "Sobald du den Flug gekostet hast, wirst du für immer auf der Erde wandeln mit den Augen zum Himmel gerichtet, denn dort warst du, und dorthin wirst du immer zurückkehren wollen.", author: "Leonardo da Vinci" },
  { id: 2, text: "Das Fliegen ist der Beweis, dass wir mit Willenskraft das Unmögliche erreichen können.", author: "Eddie Rickenbacker" },
  { id: 3, text: "Die Luft dort oben in den Wolken ist rein und fein, erfrischend und köstlich. Und warum sollte sie das nicht sein? Es ist dieselbe, die die Engel atmen.", author: "Mark Twain" },
  { id: 4, text: "Manchmal fühlt sich das Fliegen zu göttlich an, um von Menschen erreicht zu werden. Manchmal scheint die Welt von oben zu schön, zu wunderbar, zu fern für menschliche Augen.", author: "Charles A. Lindbergh" },
  { id: 5, text: "Der Himmel ist nicht die Grenze, er ist das Zuhause für diejenigen, die die Luftfahrt lieben.", author: "Anonym" }
];

const QUOTE_INTERVAL_MS = 10000;
const QUOTE_FADE_MS = 700;

const Hero: React.FC = () => {
  const [videoError, setVideoError] = useState<boolean>(false);
  const [quoteIndex, setQuoteIndex] = useState<number>(() => Math.floor(Math.random() * quotes.length));
  const [quoteVisible, setQuoteVisible] = useState<boolean>(true);

  // Zitate langsam rotieren lassen – ruhig wie Thermikfliegen
  useEffect(() => {
    let fadeTimeout: ReturnType<typeof setTimeout>;
    const interval = setInterval(() => {
      setQuoteVisible(false);
      fadeTimeout = setTimeout(() => {
        setQuoteIndex(prev => (prev + 1) % quotes.length);
        setQuoteVisible(true);
      }, QUOTE_FADE_MS);
    }, QUOTE_INTERVAL_MS);

    return () => {
      clearInterval(interval);
      clearTimeout(fadeTimeout);
    };
  }, []);

  const currentQuote = quotes[quoteIndex];

  const scrollToNextSection = () => {
    const aboutSection = document.getElementById('ueber-uns');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback: zur Hero-Höhe scrollen
      window.scrollTo({ top: window.innerHeight * 0.8, behavior: 'smooth' });
    }
  };

  return (
    <div className="relative">
      <div className="w-full h-[60vh] md:h-[70vh] lg:h-[80vh] overflow-hidden bg-gray-900">
        {!videoError ? (
          <video
            className="w-full h-full object-cover object-center"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            poster="/content/Flugsportverein_Bilder_2.jpg"
            onError={() => setVideoError(true)}
          >
            {/* Updated video source to use Timeline 1.mp4 */}
            <source src="/videos/Timeline 1.mp4" type="video/mp4" />
            <source src="/videos/Timeline%201.mp4" type="video/mp4" />
            Ihr Browser unterstützt das Video-Element nicht.
          </video>
        ) : (
          <img 
            src="/content/Flugsportverein_Bilder_2.jpg" 
            alt="Flugsportverein Otto Lilienthal" 
            className="w-full h-full object-cover object-center"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-night/70 via-night/25 to-night/10 flex flex-col items-center justify-center">
          <div
            className={`text-center max-w-4xl mx-auto px-4 min-h-[11rem] md:min-h-[13rem] flex flex-col justify-center transition-opacity duration-700 ease-out ${
              quoteVisible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <blockquote className="text-white text-2xl md:text-3xl lg:text-4xl font-serif italic leading-relaxed drop-shadow-2xl mb-4">
              „{currentQuote.text}"
            </blockquote>
            <cite className="text-white text-lg md:text-xl font-medium not-italic drop-shadow-2xl">
              — {currentQuote.author}
            </cite>
          </div>
          
          {/* Mehr erfahren Button */}
          <Button onClick={scrollToNextSection} className="mt-8 shadow-lg">
            Mehr erfahren
          </Button>
          
          {/* Scroll-Indikator Pfeil */}
          <div className="mt-6 animate-bounce">
            <svg 
              className="w-6 h-6 text-white cursor-pointer" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              onClick={scrollToNextSection}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 